








import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { lazyConfig } from "@/config/config";
import { isIos } from "@/utils/lodash";
@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class LazyLoad extends Vue {
  private delayTime: number = 200;
  private isMounted: boolean = false;

  get config() {
    const findConfig = lazyConfig.find((item: any) => {
      return (this.$route as any).name === item.route_name;
    });
    return findConfig;
  }

  private created() {
    if (isIos()) {
      this.delayTime = 100;
    } else {
      //安卓手机性能不足，只能延迟时间稍长
      this.delayTime = 300;
    }
  }

  private mounted() {
    setTimeout(() => {
      this.isMounted = true;
    }, this.delayTime);
  }
}
